import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  placeholder: {
    marginTop: Spacing.XS,
    marginBottom: Spacing.S,
  },
  type: {
    textAlign: 'center',
  },
})

interface Props extends ViewProps {}

const UploadDragging = (props: Props) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text style={styles.placeholder}>
        <Trans>Drop the file here</Trans>
      </Text>
      <Text style={styles.type} level={7}>
        <Trans>JPG, PNG or BMP</Trans>
      </Text>
    </View>
  )
}

export default UploadDragging
